import PersonIcon from '@mui/icons-material/Person'
import { Container, Grid } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import Heading from './Heading'
import RemoteUserPicker from './RemoteUserPicker'

const useStyles = makeStyles((theme) => ({
    grid: {
        marginTop: theme.spacing(3),
    },
}))

export default function MiniRemoteUserPicker(props) {
    const classes = useStyles()

    return (
        <Container maxWidth="sm">
            <Heading icon={<PersonIcon />}>
                Please choose a patient
            </Heading>
            <Grid className={classes.grid} container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <RemoteUserPicker label={props.label || "Customers"} />
                </Grid>
            </Grid>
        </Container>
    )
}
